import { FC } from 'react';
import { SegmentedButtons } from 'src/components/SegmentedButtons';
import { Option, SelectBox } from 'src/components/SelectBox';
import { CommunicationTiming } from 'src/types/automation';

type StepTimingControlsProps = {
  label: string;
  timing?: CommunicationTiming;
  onTimingChange?: (timing: CommunicationTiming) => void;
  timeWindowOptions?: Option[];
  selectedTimeWindowOption?: Option;
  onTimeWindowChange?: (option: Option) => void;
  disabled?: boolean;
};

const TIMING_OPTIONS = [
  { value: 'earliest', label: 'At the earliest eligible time' },
  { value: 'window', label: 'In a specific time window' },
];

export const StepTimingControls: FC<StepTimingControlsProps> = ({
  label,
  timing,
  onTimingChange,
  timeWindowOptions,
  selectedTimeWindowOption,
  onTimeWindowChange,
  disabled = false,
}) => {
  return (
    <div className="w-full max-w-[33rem]">
      <label className="block text-sm font-medium text-neutral-700">
        {label}
      </label>
      <div className="mt-2">
        <SegmentedButtons
          value={timing || TIMING_OPTIONS[0].value}
          onValueChange={(value) =>
            onTimingChange?.(value as CommunicationTiming)
          }
          buttons={TIMING_OPTIONS}
          disabled={disabled}
        />
      </div>
      {timing === 'window' && timeWindowOptions && (
        <div className="mt-3">
          <SelectBox
            options={timeWindowOptions}
            defaultValue={selectedTimeWindowOption}
            variant="outlined"
            color="primary"
            size="medium"
            onChange={(value) => {
              if (!onTimeWindowChange) return;
              const option = timeWindowOptions.find((o) => o.value === value);
              if (option) onTimeWindowChange(option);
            }}
            className="w-full max-w-[33rem] bg-neutral-0"
            disabled={disabled}
          />
        </div>
      )}
    </div>
  );
};

export default StepTimingControls;
